// extracted by mini-css-extract-plugin
export default {"root":"GCzA3q"};